import InputAdornment from '@mui/material/InputAdornment';
import Chip from '@mui/material/Chip';
import { Input, type InputProps } from './Input';
import { digitsOnlyNational, INDIA_COUNTRY_CODE } from '@/shared/utils/phone';

export type PhoneInputProps = Omit<InputProps, 'type' | 'onChange' | 'value'> & {
  value?: string;
  onChange?: (digits: string) => void;
  /** Optional leading icon shown before the +91 chip (e.g. WhatsApp). */
  leadingIcon?: React.ReactNode;
};

export function PhoneInput({
  value = '',
  onChange,
  leadingIcon,
  helperText = 'Enter your 10-digit number',
  placeholder = '9876543210',
  InputProps: inputPropsFromParent,
  inputProps,
  ...rest
}: PhoneInputProps) {
  return (
    <Input
      {...rest}
      value={value}
      placeholder={placeholder}
      helperText={helperText}
      onChange={(event) => {
        onChange?.(digitsOnlyNational(event.target.value));
      }}
      InputProps={{
        ...inputPropsFromParent,
        startAdornment: (
          <InputAdornment position="start" sx={{ gap: 0.5 }}>
            {leadingIcon}
            <Chip
              label={INDIA_COUNTRY_CODE}
              size="small"
              sx={{
                bgcolor: 'rgba(26,46,26,0.06)',
                color: 'primary.main',
                fontWeight: 700,
                border: '1px solid rgba(26,46,26,0.08)',
                borderRadius: 'var(--radius-sm)',
                height: 30,
                '& .MuiChip-label': { px: 1.2 },
              }}
            />
          </InputAdornment>
        ),
      }}
      inputProps={{
        inputMode: 'numeric',
        autoComplete: 'tel-national',
        maxLength: 10,
        ...inputProps,
      }}
    />
  );
}
